// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__3NPxz","header":"styles_header__2BjLs","content":"styles_content__2WN_Q"};